<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.smAndDown" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="register-service-btn" color="success">
        <v-icon left>add</v-icon>
        Register Service
      </v-btn>
    </template>
    <v-card dark>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Register Service</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card>
      <v-card-text>
        <ServiceForm ref="serviceComponent" v-on:validate="onValidate" v-on:submit="onSubmit" v-on:block="onBlock" :releaseTag.sync="releaseTag" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="!isValidated || isBlocked" :loading="isSaving" @click="submit()">
          <v-icon left>done</v-icon>
          Save
        </v-btn>
        <v-btn flat :disabled="isBlocked" @click="close()">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ServiceForm from '../ServiceForm'

  import { createNamespacedHelpers } from 'vuex'
  const linkedServices = createNamespacedHelpers('linkedservices')
  
  export default {
    components: {
      ServiceForm,
    },
    data: () => ({
      dialog: false,
      isValidated: false,
      isBlocked: false,
      isSaving: false,
      releaseTag: '',
    }),
    methods: {
      ...linkedServices.mapActions(['getLinkedServices']),
      onValidate(result) {
        this.isValidated = result
      },
      onBlock(result) {
        this.isBlocked = result
      },
      close() {
        this.reset()
        this.dialog = false
      },
      async onSubmit(service) {
        this.setStateSaving(true)

        try {
          await this.$store.dispatch('services/addService', service)
          this.getLinkedServices()
          this.close()
        } catch (error) {
          this.$refs.serviceComponent.setMessageState(false, 'Failed to save.', error.Message)
        } finally {
          this.setStateSaving(false)
        }
      },
      submit() {
        this.$refs.serviceComponent.submit()
      },
      reset() {
        setTimeout(function() {
          this.isSaving = false
          this.isValidated = false
          this.releaseTag = ''
          this.$refs.serviceComponent.resetForm()
        }.bind(this), 300)
      },
      setStateSaving(value) {
        this.isSaving = value
        this.isBlocked = value
      },
    },
  }
</script>

<style scoped>
  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>